<template>
	<div class="app-main">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>供货类别</span>
		</div>
        <div style="padding-bottom: 5px;">
			<el-alert description="提示: 请请选择供货类别"></el-alert>
		</div>
        <div>
            <el-cascader
                size="mini"
                style="width:300px;margin:10px 10px 10px 0"
                :options="classOptions"
                :props="props"
                placeholder="请选择供货类别"
                collapse-tags
                v-model="classSel"
                @change="handleChange"
                clearable>
            </el-cascader>
            <el-button type="primary" @click="saveClassSel" :disabled="classSel.length<1" size="mini">保存</el-button>
        </div>
		<el-row class="mg-b5">
            <el-table :data="tableData" size="mini" border :header-cell-style="headerCellStyle">
                <el-table-column prop="code" label="分类编码"></el-table-column>
                <el-table-column prop="name" label="分类名称"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="delClass(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
		</el-row>
		<div v-if="!preview" style="text-align: center;">
			<span slot="footer" class="dialog-footer">
				<el-button @click="backStep" size="small">上一步</el-button>
				<el-button type="primary" @click="nextStep" size="small">下一步</el-button>
			</span>
		</div>
	</div>
</template>

<script>
	import { supplierInfoById, editSupplierInfo,gysAddClassSaveList,supplierInfoBasicClassifyList , gysdelClassifyList,addSupplierApprovalMx,
		getSupplierApprovalMx} from '@/api/gys/supplierInfo.js'
	import { queryByParentId } from '@/api/basic/commodityClassification.js'
	export default {
		name: "JyClassify",
		computed: {},
		props: {
			basicId: {
				type: Number,
			},
            preview: {
                type: Boolean,
                default: false
			},
			otherInfo: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
                props: { multiple: true},
                classOptions:[],
				classSel:[],
                allList:[],
				title: "",
				tableData: [],
				ids: [],
				form: {},
				loadingInstance: undefined,
				openDialog: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: '',
						hId: this.basicId,
					}
				},
				rules: {
					bankNumber: [{
						required: true,
						type: 'number',
						message: '请输入银行账号',
						trigger: 'blur'
					}],
					bankLineNum: [{
						required: true,
						message: '请输入银行行号',
						trigger: 'blur'
					}],
					accountName: [{
						required: true,
						message: '请输入账户名称',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
            this.getMenuData();
            this.getClassList();
		},
		methods: {
            async getMenuData(){
				let _this = this;
				const { data: res } = await queryByParentId({});
				if (res.code == 0) {
					if(res.data){
						let nodes = res.data[0]&&res.data[0].children?res.data[0].children : [];
                        let newlist = [];
                        let allList = [];
                        this.filterClassData(nodes,newlist,[],allList);
                        this.classOptions = newlist;
                        this.allList = allList;
					}
				}
			},
            filterClassData(list,newList,idpath,allList){
                let allLists = allList
                list.forEach((item,index)=>{
                    let obj = {
                        value:item.id,
                        label:item.name,
                        code:item.code,
                        idpath:[...idpath,item.id]
                    }
                    allList.push(obj)
                    newList[index] = obj;
                    if(item.children && item.children.length>0){
                        newList[index]['children'] = [];
                        this.filterClassData(item.children,newList[index]['children'],newList[index]['idpath'],allLists)
                    }
                })
            },
            saveClassSel(){
                let data = [];
                this.classSel.forEach((item)=>{
                    let itemL = item.length;
                    let lastId = item[itemL-1];
                    this.allList.forEach((row)=>{
                        if(row.value == lastId){
                            // data.push({
                            //     id:row.value,
                            //     code:row.code,
                            //     name:row.label,
                            //     // idpath:row.idpath,
							// })
							// console.log(row)
                            data.push({
                                supplierInfoId:this.basicId,
								commodityClassificationId:row.value,
								code:row.code,
								name:row.label,
                            })
                        }
                    })
                })
                console.log(data)
				let oldObj = {};
				let oldData = [...this.tableData];
				oldData.forEach((oitem)=>{
					oldObj[`${oitem.code}_${oitem.name}`] = true;
				})
				data.forEach((nitem)=>{
					if(!oldObj[`${nitem.code}_${nitem.name}`]){
						oldData.push(nitem)
					}
				})
				addSupplierApprovalMx({
					classType:'com.srm.entity.SupplierInfoBasicClassify',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
					jsonData:JSON.stringify(oldData)
				}).then((res)=>{
                    console.log(res)
					this.getClassList()
				})

            },
			getClassList(){
				let pramar = {
					classType:'com.srm.entity.SupplierInfoBasicClassify',
					classTypeIndex:'0',
					supplierInfoId:this.basicId,
				};
				if(this.otherInfo.lastPass){
					pramar['queryType']='lastPass'
				}
				getSupplierApprovalMx(pramar).then(({data:res}) => {
					console.log(res)
					this.tableData = [];
					if(res.data && res.data.jsonData){
						this.tableData = JSON.parse(res.data.jsonData)
						this.classSel = []
					}
				})
			},
            delClass(row){
				let _this = this;
				let newData = [];
				let oldData = [...this.tableData];
				oldData.forEach((oitem)=>{
					if(`${oitem.code}_${oitem.name}` == `${row.code}_${row.name}`){

					}else{
						newData.push(oitem)
					}
				})
				console.log(newData)
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						addSupplierApprovalMx({
							classType:'com.srm.entity.SupplierInfoBasicClassify',
							classTypeIndex:'0',
							supplierInfoId:_this.basicId,
							jsonData:JSON.stringify(param)
						}).then((res)=>{
							_this.getClassList()
						})
					},
					data:newData //参数对象 主要回调函数用
				});

            },
            handleChange(value) {
				console.log(value);

			},
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList();
			},
			async getList() {
				// let _this = this;
				// const {
				// 	data: res
				// } = await supplierBankIdList(_this.quertInfo)
				// if (res.code == 0) {
				// 	_this.tableData = res.data;
				// 	_this.count = res.count;
				// }
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if (_this.form.id != undefined) {
							editSupplierBankID(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							addSupplierBankID(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			//上一步
			backStep: function() {
				this.bus.$emit('stepsFun', 1);
			},
			//下一步
			nextStep: function() {
				if (this.tableData.length <= 0) {
					this.$notify({
						message: '请至少添加一条供货类别',
						type: 'error'
					});
					return false;
				}
				this.bus.$emit('stepsFun', 3);
			},
		},
        watch:{
            classSel:function(val){
                console.log(val)
            },
        }
	};
</script>
<style scoped="scoped">
</style>
